import {useRouteNode} from 'react-router5';
import React, { useState} from 'react';

import './style/carto.css';
import Tab from '../components/tab/tab';

import CartoLink from './carto_link';
import CartoGeoCE from './carto_geo_ce';
import AggView from './agg_view';

import EntityView from "../explore/entities/entityView";
import ContactView from "../explore/contacts/contactView";
import SearchCarto from "./searchCarto";
import {useTranslation} from "react-i18next";


function Carto() {
  let { router } = useRouteNode("carto");
  const { t } = useTranslation();
  let {name, data} = router.getState();
  if (name === "carto") { name = "carto.link"; }

  let [, carto_type, item_type] = name.split(".");

  const [agg_view, setAggView] = useState(null)
  const [focused,setFocused] = useState(false);
  const [focusNode,setFocusNode] = useState(null);

  const onClickCartoLink = (id, data) => {
    // check id, check type and unselect if same
    const route = "carto.link." + data.type;
    setFocusNode(null);
    router.navigate(route, {id}, {reload: true})
  };

  const onClickCartoCE = (id, type) => {
    // check id, check type and unselect if same
    const route = "carto.geo." + type;
    setFocusNode(null);
    router.navigate(route, {id}, {reload: true})
  };

  const onClickAggCartoCE = ({ contacts, entities, poi_geo_id }) => {
    const route_suffix = contacts.length > 0 ? "contacts" : "entities";
    console.log("onClickAggCartoCE");
    router.navigate("carto.geo.agg." + route_suffix, null, {}, () => {
      setAggView({ contacts, entities, poi_geo_id });
    })
  };

  const handleFocus =  (id,type) =>{
    setFocused(false);
    setFocusNode({id:id,type:type});
  }

  const onClose = () => {
    // may trigger a setState in unmounted component because of useRouteNode
    router.navigate(`carto.${carto_type}`, {}, {reload: true});
  }

  let col1, col2 = false;
  let col2_width = 0;
  if (carto_type === "link") {
    col1 = <CartoLink links={data.links} contacts={data.contacts} trending={data.trending} affiliations={data.affiliations || []}
                      entities={data.entities} onClick={onClickCartoLink} focusNode={focusNode} focused={focused} setFocused={setFocused}
                      map_settings={data.map_settings_contact_entity_network} />
  } else {
    col1 = <CartoGeoCE contacts={data.contacts} entities={data.entities} navigation_opts={data.map_navigation}
                       geos={data.geos} onClick={onClickCartoCE} onClickAgg={onClickAggCartoCE} focusNode={focusNode} focused={focused} setFocused={setFocused}
                       map_settings={data.map_settings_contact_entity_geo}/>
  }

  if (item_type === "agg" && agg_view) {
    col2 = <AggView entities={agg_view.entities} contacts={agg_view.contacts} key={agg_view.poi_geo_id} />;
    col2_width = 30;
  } else {
    if (item_type === "entity") {
      col2 = <EntityView key={data.entity.id} entity={data.entity} component_route={`carto.${carto_type}.entity`} onClose={onClose} />
      col2_width = 50;
    } else if (item_type === "contact") {
      col2 = <ContactView key={data.contact.id} contact={data.contact} component_route={`carto.${carto_type}.contact`} onClose={onClose} />
      col2_width = 50;
    }
  }

  const tabContent = [
    {"title": t("Geography"), "root": "carto.geo"},
    {"title": t("Networks"), "root": "carto.link"},
  ]

  const full_height_style = {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    alignItems: "stretch"
  }

  const full_height_style_col1 = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "stretch",
    width: (100 - col2_width) + "%"
  }

  return <section className="c-container_global" style={full_height_style}>
    <section className="c-container container_one" style={full_height_style_col1}>
      <div className="c-container_menu">
        <Tab active={tabContent.map(x => x.root).indexOf(name)}>
          {
            tabContent.map((tab, idx) => (
              <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root}></Tab.TabPane>)
            )
          }
        </Tab>
      </div> {/*menu  Tabs */}
      <div style={{flex: 1,position:"relative"}}>
        <div className={"c-search_bar_carto c-search_bar_carto_type-" + carto_type}>
          <SearchCarto handleFocus={handleFocus} dataList={data.contacts} dataListEntities={data.entities} dataListContacts={data.contacts}/>
        </div>
      { col1 }
      </div>
    </section>
    {
      col2 && <section className="c-container container_two" style={{width: col2_width + "%"}}>
        { col2 }
      </section>
    }
  </section>
}

export default Carto

